// Wait for DetailsDisclosure to be available before defining ShareButton.
(function defineShareButton() {
  if (typeof DetailsDisclosure === 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', defineShareButton);
    } else {
      setTimeout(defineShareButton, 100);
    }
    return;
  }

  var MAX_SHARE_COPY_LENGTH = 300;
  var DEEP_LINK_FALLBACK_DELAY_MS = 500;
  var ORAL_MIRACLE_EMAIL_SUBJECT = 'They cracked remineralization';
  var DEEPSLEEP_EMAIL_SUBJECT = 'Thought of you when I found this \ud83c\udf19';
  /** DeepSleep share CTA + modal URL: Sleep Guide (not PDP). Referral appended in buildProductShareData when logged in. */
  var DEEPSLEEP_SHARE_GUIDE_URL = 'https://immunizelabs.com/pages/sleep-guide';

  function getMetaContent(selectors) {
    var list = Array.isArray(selectors) ? selectors : [selectors];
    for (var i = 0; i < list.length; i++) {
      var el = document.querySelector(list[i]);
      if (!el) continue;
      var content = (el.getAttribute('content') || '').trim();
      if (content) return content;
    }
    return '';
  }

  function normalizeWhitespace(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function truncateText(text, maxLength) {
    var value = normalizeWhitespace(text);
    var limit = typeof maxLength === 'number' ? maxLength : 100;
    if (value.length <= limit) return value;
    return value.slice(0, limit).trim();
  }

  function truncateForLength(text, maxLength) {
    var value = normalizeWhitespace(text);
    if (maxLength <= 0) return '';
    if (value.length <= maxLength) return value;
    if (maxLength <= 3) return value.slice(0, maxLength);
    return value.slice(0, maxLength - 3).trim() + '...';
  }

  function fitShareMessage(prefix, title, suffix, maxLength) {
    var normalizedPrefix = String(prefix || '');
    var normalizedSuffix = String(suffix || '');
    var safeTitle = normalizeWhitespace(title) || 'this product';
    var candidate = normalizeWhitespace(normalizedPrefix + safeTitle + normalizedSuffix);

    if (candidate.length <= maxLength) return candidate;

    for (var titleLimit = safeTitle.length; titleLimit >= 0; titleLimit--) {
      var truncatedTitle = titleLimit === 0 ? '' : truncateForLength(safeTitle, titleLimit);
      var fallbackTitle = truncatedTitle || 'this product';
      candidate = normalizeWhitespace(normalizedPrefix + fallbackTitle + normalizedSuffix);
      if (candidate.length <= maxLength) return candidate;
    }

    return '';
  }

  // Combined detection: iOS/Android user agent OR mobile viewport width.
  function isMobileShareDevice() {
    var ua = navigator.userAgent || '';
    var byUA = /Android|iPhone|iPad|iPod/i.test(ua);
    var byWidth = window.innerWidth <= 768;
    return byUA || byWidth;
  }

  function sanitizeFirstName(name) {
    return normalizeWhitespace(name).split(' ')[0] || '';
  }

  function buildReferralCode(name, customerId) {
    var slug = sanitizeFirstName(name).toLowerCase().replace(/[^a-z0-9]/g, '');
    if (!slug) slug = 'customer';
    return slug + '_' + String(customerId || '').trim();
  }

  function appendReferralToUrl(rawUrl, referralCode) {
    var url = String(rawUrl || '').trim();
    if (!url || !referralCode) return url;

    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.set('ref', referralCode);
      return parsed.toString();
    } catch (err) {
      var separator = url.indexOf('?') === -1 ? '?' : '&';
      return url + separator + 'ref=' + encodeURIComponent(referralCode);
    }
  }

  /** OralMiracle PDP share: multi-line body; do not run through normalizeWhitespace (preserves bullets / paragraphs). */
  function getOralMiracleShareBodyText() {
    return (
      'Someone who cares about you wanted you to see this.\n\n' +
      'They\u2019ve basically cracked the code on remineralization\u2014and it works overnight while you sleep for less than $1 a day.\n\n' +
      'It\u2019s not just another mouthwash. There\u2019s a specific process behind it:\n\n' +
      '\u2022 Neutralizes cavity-causing bacteria in about 60 seconds\n' +
      '\u2022 Optimizes pH so minerals can actually bind to enamel\n' +
      '\u2022 Uses dual-action remineralization (nHAp + CPP-ACP) to reach both surface and deeper areas\n' +
      '\u2022 Stays active for 4 hours\u2014giving you 240X more contact time than hydroxyapatite toothpaste ever can!\n\n' +
      'The idea is simple: create the right environment, then give minerals enough time to actually do their job.\n\n' +
      'If you\u2019re curious, it\u2019s worth a look:'
    ).trim();
  }

  /** DeepSleep Formula PDP: full email-style body; Sleep Guide URL after CTA (referral-safe). */
  function getDeepSleepShareBodyText(signerDisplayName, ctaUrl) {
    var sign = String(signerDisplayName || '').trim() || 'A friend';
    var url = String(ctaUrl || '').trim();
    var ctaLine = url ? '\ud83d\udc49 Try DeepSleep: ' + url : '\ud83d\udc49 Try DeepSleep:';
    return (
      'Not another melatonin thing \u2014 this one actually works differently.\n\n' +
      'Hey there,\n\n' +
      'Someone who cares about you wanted you to see this.\n\n' +
      "I've been using DeepSleep for a few weeks now, and honestly? It's the first thing that's helped me wake up feeling actually rested \u2014 not groggy, not wired, just\u2026 restored.\n\n" +
      "It's not just another sleep supplement. Here's why it's different:\n\n" +
      '\u2728 Works with your biology, not against it\n' +
      'Instead of knocking you out with heavy sedation, it gently downshifts an over-alert nervous system so you can naturally wind down.\n\n' +
      '\u2728 One formula, seven pathways\n' +
      'Most supplements target just one thing (melatonin, magnesium, etc.). DeepSleep aligns all seven signals your body needs for deep, continuous sleep \u2014 stress chemistry, muscle tension, circadian timing, recovery, and more.\n\n' +
      '\u2728 No dependency, no crash\n' +
      'Non-habit forming. No morning fog. Just better sleep architecture \u2014 the kind that leaves you clear-headed and ready.\n\n' +
      '\u2728 Built for people who\'ve "tried everything"\n' +
      'If melatonin, CBD, or sleep teas gave you a week of relief then stopped working\u2026 this is built for that exact frustration.\n\n' +
      'The idea is simple: align the signals, and sleep has room to show up.\n\n' +
      "If you're tired of feeling tired \u2014 or know someone who is \u2014 it's worth a look:\n\n" +
      ctaLine +
      '\n\n' +
      '(P.S. They offer a $4.99 sample if you want to test it risk-free first.)\n\n' +
      'No pressure \u2014 just sharing something that genuinely helped me.\n\n' +
      'Sleep well,\n' +
      sign
    ).trim();
  }

  function buildOralMiracleMessage(shareUrl) {
    var body = getOralMiracleShareBodyText();
    return {
      bodyText: body,
      copyText: body + '\n\n' + shareUrl,
      emailSubject: ORAL_MIRACLE_EMAIL_SUBJECT,
      urlEmbeddedInMessage: false,
      preserveMultilineShare: false,
    };
  }

  function buildDeepSleepMessage(customerFirstName, shareUrl) {
    var sign = sanitizeFirstName(customerFirstName) || 'A friend';
    var body = getDeepSleepShareBodyText(sign, shareUrl);
    return {
      bodyText: body,
      copyText: body,
      emailSubject: DEEPSLEEP_EMAIL_SUBJECT,
      urlEmbeddedInMessage: true,
      preserveMultilineShare: true,
    };
  }

  function buildDefaultMessage(productTitle, shareUrl) {
    var t = normalizeWhitespace(productTitle) || 'this product';
    var body = 'Check out ' + t + ':';
    var copy = truncateForLength(normalizeWhitespace(body + ' ' + shareUrl), MAX_SHARE_COPY_LENGTH);
    return {
      bodyText: body,
      copyText: copy,
      emailSubject: t,
      urlEmbeddedInMessage: false,
      preserveMultilineShare: false,
    };
  }

  function buildProductShareData(host, urlToShare) {
    var hostData = (host && host.dataset) || {};
    var fallbackTitle = getMetaContent(['meta[property="og:title"]', 'meta[name="twitter:title"]']) || document.title || '';
    var fallbackDescription =
      getMetaContent(['meta[property="og:description"]', 'meta[name="description"]', 'meta[name="twitter:description"]']) || '';

    var title = normalizeWhitespace(hostData.shareProductTitle || fallbackTitle || 'this product');
    var description = truncateText(hostData.shareProductDescription || fallbackDescription || '', 100);
    var productUrl = String(urlToShare || hostData.shareProductUrl || window.location.href || '').trim();

    var customerName = normalizeWhitespace(hostData.customerName || '');
    var customerId = normalizeWhitespace(hostData.customerId || '');
    var isLoggedIn = String(hostData.isLoggedIn || '').toLowerCase() === 'true' && !!customerName && !!customerId;

    var shareTemplate = String(hostData.shareCopyTemplate || 'default').trim().toLowerCase();

    var shareUrl = productUrl;
    var messageData;
    var referralCode;

    if (shareTemplate === 'oral-miracle') {
      if (isLoggedIn) {
        referralCode = buildReferralCode(customerName, customerId);
        shareUrl = appendReferralToUrl(productUrl, referralCode);
      }
      messageData = buildOralMiracleMessage(shareUrl);
    } else if (shareTemplate === 'deepsleep') {
      shareUrl = DEEPSLEEP_SHARE_GUIDE_URL;
      if (isLoggedIn) {
        referralCode = buildReferralCode(customerName, customerId);
        shareUrl = appendReferralToUrl(DEEPSLEEP_SHARE_GUIDE_URL, referralCode);
        messageData = buildDeepSleepMessage(customerName, shareUrl);
      } else {
        messageData = buildDeepSleepMessage('', shareUrl);
      }
    } else {
      if (isLoggedIn) {
        referralCode = buildReferralCode(customerName, customerId);
        shareUrl = appendReferralToUrl(productUrl, referralCode);
      }
      messageData = buildDefaultMessage(title, shareUrl);
    }

    var textForShare = messageData.bodyText || description || title;
    var copyText = messageData.copyText || normalizeWhitespace(textForShare + ' ' + shareUrl);

    return {
      title: title,
      text: textForShare,
      url: shareUrl,
      copyText: copyText,
      emailSubject: messageData.emailSubject || title,
      urlEmbeddedInMessage: !!messageData.urlEmbeddedInMessage,
      preserveMultilineShare: !!messageData.preserveMultilineShare,
      isLoggedIn: isLoggedIn,
      customerName: customerName,
      customerId: customerId,
    };
  }

  function shareTextIncludesUrl(shareData, url) {
    if (!shareData || !shareData.urlEmbeddedInMessage || !url) return false;
    var t = String((shareData && shareData.text) || '');
    return t.indexOf(url) !== -1;
  }

  function buildShareCombinedText(shareData, url, text) {
    var t = String(text || '');
    var u = String(url || '').trim();
    if (shareData && shareData.preserveMultilineShare) {
      if (shareTextIncludesUrl(shareData, u)) return t.trim();
      return (t.trim() + (u ? '\n\n' + u : '')).trim();
    }
    var trimmed = t.trim();
    if (shareTextIncludesUrl(shareData, u)) {
      return normalizeWhitespace(trimmed);
    }
    return normalizeWhitespace((trimmed ? trimmed + ' ' : '') + u);
  }

  function getModalShareInput() {
    return document.getElementById('shareUrl');
  }

  function syncModalCopyField(productData) {
    var shareUrlInput = getModalShareInput();
    if (!shareUrlInput) return;
    shareUrlInput.value = (productData && (productData.copyText || productData.url)) || window.location.href;
  }

  function clearProductShareContext() {
    window.__productShareContext = null;
  }

  function getWebShareUrl(platform, shareData) {
    var url = String((shareData && shareData.url) || window.location.href || '').trim();
    var title = String((shareData && shareData.title) || document.title || '').trim();
    var text = String((shareData && shareData.text) || '').trim();
    var combinedText = buildShareCombinedText(shareData, url, text);
    var encodedUrl = encodeURIComponent(url);
    var encodedTitle = encodeURIComponent(title);
    var encodedText = encodeURIComponent(text || title);
    var encodedCombinedText = encodeURIComponent(combinedText);

    switch (platform) {
      case 'facebook':
        return 'https://www.facebook.com/sharer/sharer.php?u=' + encodedUrl;
      case 'twitter':
        return 'https://twitter.com/intent/tweet?url=' + encodedUrl + '&text=' + encodedText;
      case 'whatsapp':
        return 'https://api.whatsapp.com/send?text=' + encodedCombinedText;
      case 'linkedin':
        return 'https://www.linkedin.com/shareArticle?mini=true&url=' + encodedUrl + '&title=' + encodedTitle;
      case 'pinterest':
        return 'https://pinterest.com/pin/create/button/?url=' + encodedUrl + '&description=' + encodedText;
      case 'email':
        var subj = (shareData && shareData.emailSubject) || ORAL_MIRACLE_EMAIL_SUBJECT;
        var body = text;
        if (!shareTextIncludesUrl(shareData, url) && url) {
          body = (body ? body + '\n\n' : '') + url;
        }
        body = (body || '') + '\n';
        return 'mailto:?subject=' + encodeURIComponent(subj) + '&body=' + encodeURIComponent(body);
      default:
        return '';
    }
  }

  function getDeepLinkUrl(platform, shareData) {
    var url = String((shareData && shareData.url) || window.location.href || '').trim();
    var title = String((shareData && shareData.title) || document.title || '').trim();
    var text = String((shareData && shareData.text) || '').trim();
    var combinedText = buildShareCombinedText(shareData, url, text);
    var encodedUrl = encodeURIComponent(url);
    var encodedText = encodeURIComponent(text || title);
    var encodedCombinedText = encodeURIComponent(combinedText);

    switch (platform) {
      case 'facebook':
        return 'fb://share?url=' + encodedUrl;
      case 'twitter':
        return 'twitter://post?message=' + encodedText + '&url=' + encodedUrl;
      case 'whatsapp':
        return 'whatsapp://send?text=' + encodedCombinedText;
      default:
        return '';
    }
  }

  function attemptMobileDeepLink(platform, shareData) {
    var deepLinkUrl = getDeepLinkUrl(platform, shareData);
    if (!deepLinkUrl) return false;

    var didHide = false;
    function onVisibilityChange() {
      if (document.hidden) didHide = true;
    }
    document.addEventListener('visibilitychange', onVisibilityChange);

    console.log('[Share] Mobile Layer 2: deep-link attempt for', platform);
    window.location.href = deepLinkUrl;

    setTimeout(function() {
      document.removeEventListener('visibilitychange', onVisibilityChange);
      if (!didHide && !document.hidden) {
        var fallbackUrl = getWebShareUrl(platform, shareData);
        if (fallbackUrl) {
          console.log('[Share] Mobile Layer 3: deep-link failed, opening web fallback for', platform);
          window.open(fallbackUrl, '_blank', 'noopener,noreferrer');
        }
      }
    }, DEEP_LINK_FALLBACK_DELAY_MS);

    return true;
  }

  function installProductShareModalOverrides() {
    if (window.__productShareOverridesInstalled) return;
    window.__productShareOverridesInstalled = true;

    document.addEventListener(
      'click',
      function(e) {
        var target = e.target;
        if (!target || typeof target.closest !== 'function') return;

        var shareOption = target.closest('.share-option[data-platform]');
        if (!shareOption || !window.__productShareContext) return;

        var shareModal = document.getElementById('shareModal');
        if (!shareModal || !shareModal.classList.contains('active')) return;

        var platform = shareOption.getAttribute('data-platform');
        if (!platform) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        var shareData = window.__productShareContext;

        if (platform === 'email') {
          var emailUrl = getWebShareUrl('email', shareData);
          if (emailUrl) window.location.href = emailUrl;
          return;
        }

        var isMobile = isMobileShareDevice();
        if (isMobile && (platform === 'facebook' || platform === 'twitter' || platform === 'whatsapp')) {
          if (attemptMobileDeepLink(platform, shareData)) return;
        }

        var webShareUrl = getWebShareUrl(platform, shareData);
        if (webShareUrl) {
          window.open(webShareUrl, '_blank', 'width=600,height=500,noopener,noreferrer');
        }
      },
      true
    );

    document.addEventListener(
      'click',
      function(e) {
        if (!window.__productShareContext) return;
        var target = e.target;
        if (!target || typeof target.closest !== 'function') return;

        var shareModal = document.getElementById('shareModal');
        var closeBtn = target.closest('.close-modal');
        var clickedOverlay = shareModal && target === shareModal;

        if (closeBtn || clickedOverlay) {
          setTimeout(clearProductShareContext, 0);
        }
      },
      true
    );

    document.addEventListener(
      'keydown',
      function(e) {
        if (e.key === 'Escape') clearProductShareContext();
      },
      true
    );
  }

  function openShareModalFallback(productData) {
    window.__productShareContext = productData || null;

    if (typeof window.openShareModal === 'function') {
      window.openShareModal(productData);
      syncModalCopyField(productData);
      return;
    }

    // Last-resort fallback if theme modal bootstrap has not yet initialized.
    var shareModal = document.getElementById('shareModal');
    var shareUrlInput = document.getElementById('shareUrl');
    if (shareModal && shareUrlInput) {
      window.modalJustOpened = true;
      shareUrlInput.value = (productData && (productData.copyText || productData.url)) || window.location.href;
      shareModal.classList.add('active');
      document.body.style.overflow = 'hidden';
      setTimeout(function() {
        window.modalJustOpened = false;
      }, 600);
    }
  }

  // Always open custom share popup first (mobile and desktop). On mobile, native share
  // is available via "More Share Options" inside the modal.
  function handleProductShare(productData, isMobile) {
    console.log('[Share] Device:', isMobile ? 'mobile' : 'desktop');
    console.log('[Share] Message mode:', productData && productData.isLoggedIn ? 'personalized' : 'generic');
    console.log('[Share] Opening popup modal');
    openShareModalFallback(productData);
    return Promise.resolve({ openedModal: true, nativeShared: false });
  }

  window.handleProductShare = handleProductShare;
  installProductShareModalOverrides();

  function copyTextToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function(resolve, reject) {
      try {
        var textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  }

  if (!customElements.get('share-button')) {
    customElements.define(
      'share-button',
      class ShareButton extends DetailsDisclosure {
        constructor() {
          super();

          this.elements = {
            shareSummary: this.querySelector('summary'),
            closeButton: this.querySelector('.share-button__close'),
            successMessage: this.querySelector('[id^="ShareMessage"]'),
            urlInput: this.querySelector('input'),
          };
          this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

          if (this.elements.shareSummary) {
            this.elements.shareSummary.addEventListener(
              'click',
              (e) => {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                if (this.mainDetailsToggle) {
                  this.mainDetailsToggle.removeAttribute('open');
                  this.mainDetailsToggle.open = false;
                }

                var shareData = this.getProductData();
                var isMobile = isMobileShareDevice();

                requestAnimationFrame(function() {
                  requestAnimationFrame(function() {
                    handleProductShare(shareData, isMobile).catch(function(err) {
                      console.error('[Share] Unexpected share handler error:', err);
                      openShareModalFallback(shareData);
                    });
                  });
                });
              },
              true
            );
          }

          if (this.mainDetailsToggle) {
            this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
            var copyBtn = this.mainDetailsToggle.querySelector('.share-button__copy');
            var closeBtn = this.mainDetailsToggle.querySelector('.share-button__close');
            if (copyBtn) copyBtn.addEventListener('click', this.copyToClipboard.bind(this));
            if (closeBtn) closeBtn.addEventListener('click', this.close.bind(this));
          }
        }

        getProductData() {
          var latestUrl = this.urlToShare || document.location.href;
          var data = buildProductShareData(this, latestUrl);
          this.urlToShare = data.url;
          if (this.elements.urlInput) this.elements.urlInput.value = data.copyText || data.url;
          return data;
        }

        toggleDetails() {
          if (!this.mainDetailsToggle || this.mainDetailsToggle.open) return;
          if (this.elements.successMessage) {
            this.elements.successMessage.classList.add('hidden');
            this.elements.successMessage.textContent = '';
          }
          if (this.elements.closeButton) this.elements.closeButton.classList.add('hidden');
          if (this.elements.shareSummary) this.elements.shareSummary.focus();
        }

        copyToClipboard() {
          var textToCopy = this.elements.urlInput ? this.elements.urlInput.value : this.urlToShare;
          copyTextToClipboard(textToCopy).then(() => {
            if (this.elements.successMessage) {
              this.elements.successMessage.classList.remove('hidden');
              this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
            }
            if (this.elements.closeButton) {
              this.elements.closeButton.classList.remove('hidden');
              this.elements.closeButton.focus();
            }
          });
        }

        updateUrl(url) {
          this.urlToShare = url;
          if (this.elements.urlInput) this.elements.urlInput.value = url;
        }
      }
    );
  }
})();
